import React from "react";
import PropTypes from "prop-types";

const Input = props => {
	return (
		<input
			className="form-control text-defaultRegistrationInput font-defaultRegistrationInput w-100 mb-1 item-element px-4 pb-2"
			type="text"
			{...props.attributes(props.item)}
			onChange={e => {
				props.setValue(props.item.name, e.target.value);
			}}
			onBlur={e => {
				if (e.target.value) {
					e.target.classList.add("is-valid");
				} else {
					e.target.classList.remove("is-valid");
				}
			}}
		/>
	);
};

Input.propTypes = {
	item: PropTypes.object,
	attributes: PropTypes.func,
	setValue: PropTypes.func
};

export default Input;
